var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.proposals),function(proposal){return _c('v-container',{key:proposal.id,staticClass:"pb-0"},[_c('ProductListSlider',{attrs:{"proposal":proposal,"title":proposal.descr,"paginationClass":'swiper-pagination' + proposal.id}})],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }